var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"page-title":"Accounts","page-icon":"mdi-folder-outline","collection-name":"account","items-per-page":20,"add-dialog-title":"Add Account","is-filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }